import React from 'react';
import RegistrationForm from '@/components/auth/RegistrationForm';

const RegistrationPage = () => {
  return <RegistrationForm data-id="djjs01ht4" data-path="src/pages/RegistrationPage.tsx" />;
};

export default RegistrationPage;